<template>
  <v-main>
    <v-app  id="login-view">
     <router-view></router-view>
    </v-app>
  </v-main>
</template>

<script>
export default {
  name: 'LoginView',
}
</script>

<style>

</style>
